import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	chartContainer: {
		flexGrow: 1,
		margin: `${theme.spacing(2.5)}px
                 ${-theme.spacing(1.5)}px
                 ${theme.spacing(1)}px
                 ${-theme.spacing(2)}px`
	}
}));
